import { serverApi } from "./serverApi";
import {
  CreateVariable,
  CreateVariableValue,
  DeleteVariableValue,
  Variable,
  VariableValue
} from "../types/variableType";

export const variableService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllVariables: build.query<Array<Variable>, string>({
      query: () => ({
        url: "/variable/all-variables"
      })
    }),
    createVariable: build.mutation<number, CreateVariable>({
      query: (body) => ({
        url: "/variable/variable",
        method: "POST",
        body
      })
    }),
    createVariableValue: build.mutation<void, CreateVariableValue>({
      query: (body) => ({
        url: "/variable/variable-value",
        method: "POST",
        body
      })
    }),
    updateVariableValue: build.mutation<void, VariableValue>({
      query: (body) => ({
        url: "/variable/variable-value",
        method: "PUT",
        body
      })
    }),
    deleteVariableValue: build.mutation<void, DeleteVariableValue>({
      query: (deleteVariableValue) => ({
        url: "/variable/variable-value",
        method: "DELETE",
        body: deleteVariableValue
      })
    }),
  })
});

export const {
  useGetAllVariablesQuery,
  useCreateVariableMutation,
  useCreateVariableValueMutation,
  useUpdateVariableValueMutation,
  useDeleteVariableValueMutation
} = variableService;